import React from 'react';
import './About.css';

const About = ({ t }) => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-visual">
          <div className="about-image-container">
            <div className="about-pattern"></div>
            <div className="about-floating-shapes">
              <div className="floating-shape shape-1"></div>
              <div className="floating-shape shape-2"></div>
              <div className="floating-shape shape-3"></div>
            </div>
            <div className="about-logo-display">ARB</div>
          </div>
        </div>
        <div className="about-content">
          <h2>{t.about.title}</h2>
          <p>{t.about.p1}</p>
          <p>{t.about.p2}</p>
          <p>{t.about.p3}</p>
          <div className="about-stats">
            {t.about.stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <span className="stat-number">{stat.number}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
